(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  /* ---------- mobile drawer submenus ---------- */
  function subMenus() {
    $$('[data-drawer-toggle]').forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = '1';
      b.addEventListener('click', function () {
        var g = b.closest('.drawer__group');
        if (!g) return;
        var open = g.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- search overlay + predictive results ---------- */
  var sTimer;
  function searchOverlay() {
    var sov = $('[data-sov]');
    if (!sov || sov.dataset.bound) return; sov.dataset.bound = '1';
    var input = $('[data-sov-input]', sov);
    var out = $('[data-sov-results]', sov);
    var empty = $('[data-sov-empty]', sov);
    var hint = $('[data-sov-hint]', sov);

    function set(open) {
      sov.classList.toggle('is-open', open);
      sov.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
      if (open && input) setTimeout(function () { input.focus(); }, 60);
    }
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-sov-open]');
      if (o) { e.preventDefault(); set(true); return; }
      if (e.target.closest('[data-sov-close]')) { set(false); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    if (!input || !out) return;

    input.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; if (empty) empty.hidden = true; if (hint) hint.hidden = false; return; }
      sTimer = setTimeout(function () {
        var url = root() + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url).then(function (r) { return r.json(); }).then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (hint) hint.hidden = true;
          if (empty) empty.hidden = items.length > 0;
          out.innerHTML = items.map(function (p) {
            var img = p.featured_image && p.featured_image.url
              ? '<img class="card__img" src="' + p.featured_image.url + '" alt="" loading="lazy">' : '';
            return '<a class="card" href="' + p.url + '"><div class="card__media">' + img +
              '</div><h3 class="card__title">' + p.title + '</h3></a>';
          }).join('');
        }).catch(function () { });
      }, 220);
    });
  }

  /* ---------- cart drawer ---------- */
  function setCart(open) {
    var cd = $('[data-cart-drawer]');
    if (!cd) return;
    cd.classList.toggle('is-open', open);
    cd.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  function refreshCart() {
    return fetch(root() + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var html = d['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cd-inner]');
        var cur = $('[data-cd-inner]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        var freshRoot = tmp.querySelector('[data-cart-drawer]');
        var count = freshRoot ? freshRoot.getAttribute('data-count') : null;
        if (count !== null) {
          var root_ = $('[data-cart-drawer]');
          if (root_) root_.setAttribute('data-count', count);
          $$('[data-cart-count]').forEach(function (el) {
            el.textContent = count;
            el.classList.toggle('is-hidden', count === '0');
          });
        }
      });
  }

  function changeLine(line, qty) {
    var cd = $('[data-cart-drawer]');
    if (cd) cd.classList.add('is-busy');
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(refreshCart).catch(function () { }).then(function () {
      if (cd) cd.classList.remove('is-busy');
    });
  }

  function cartEvents() {
    if (document.body.dataset.cartBound) return;
    document.body.dataset.cartBound = '1';
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-cart-open]');
      if (open && $('[data-cart-drawer]')) { e.preventDefault(); setCart(true); return; }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); setCart(false); return; }
      var ch = e.target.closest('[data-cart-change]');
      if (ch) { e.preventDefault(); changeLine(ch.getAttribute('data-line'), ch.getAttribute('data-cart-change')); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setCart(false); });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form || form.dataset.noAjax || !$('[data-cart-drawer]')) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var label = btn ? btn.textContent : '';
      var errBox = form.querySelector('[data-form-error]');
      if (errBox) { errBox.hidden = true; errBox.textContent = ''; }
      if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-adding') || label; }
      fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.status) throw new Error(d.description || d.message || 'Erreur');
          return refreshCart();
        })
        .then(function () { setCart(true); })
        .catch(function (err) {
          if (errBox) { errBox.textContent = err.message; errBox.hidden = false; }
          else { form.removeAttribute('data-no-ajax'); }
        })
        .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
    });
  }

  /* ---------- sticky add to cart (mobile) ---------- */
  function stickyAtc() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc-anchor]');
    if (!bar || !anchor || bar.dataset.bound || !('IntersectionObserver' in window)) return;
    bar.dataset.bound = '1';
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting); });
    }, { rootMargin: '0px 0px -55% 0px' }).observe(anchor);
    var go = bar.querySelector('[data-sticky-add]');
    if (go) go.addEventListener('click', function () {
      var f = document.querySelector('form[action*="/cart/add"]');
      if (!f) return;
      if (f.requestSubmit) f.requestSubmit(); else f.submit();
    });
  }

  /* ---------- gallery zoom ---------- */
  function zoom() {
    $$('[data-zoom]').forEach(function (z) {
      if (z.dataset.bound) return; z.dataset.bound = '1';
      z.addEventListener('click', function () { z.classList.toggle('is-zoom'); });
      z.addEventListener('mouseleave', function () { z.classList.remove('is-zoom'); });
      z.addEventListener('mousemove', function (e) {
        if (!z.classList.contains('is-zoom')) return;
        var r = z.getBoundingClientRect();
        var img = z.querySelector('img');
        if (img) img.style.transformOrigin =
          (((e.clientX - r.left) / r.width) * 100) + '% ' + (((e.clientY - r.top) / r.height) * 100) + '%';
      });
    });
  }

  /* ---------- recently viewed ---------- */
  function recentlyViewed() {
    var KEY = 'tresorel:recent';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list)) list = [];
    var holder = $('[data-product-handle]');
    var cur = holder ? holder.getAttribute('data-product-handle') : null;
    if (cur) {
      list = [cur].concat(list.filter(function (h) { return h !== cur; })).slice(0, 10);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { }
    }
    var box = $('[data-recent]');
    if (!box) return;
    var section = box.closest('[data-recent-section]');
    var show = list.filter(function (h) { return h !== cur; }).slice(0, Number(box.getAttribute('data-limit') || 4));
    if (!show.length) { if (section) section.hidden = true; return; }
    Promise.all(show.map(function (h) {
      return fetch(root() + 'products/' + h + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (parts) {
      var html = parts.filter(Boolean).join('');
      if (!html) { if (section) section.hidden = true; return; }
      box.innerHTML = html;
      if (section) section.hidden = false;
    });
  }

  /* ---------- collection filters and sort ---------- */
  function facetForm() {
    $$('[data-facet-form]').forEach(function (form) {
      if (form.dataset.bound) return; form.dataset.bound = '1';
      form.addEventListener('change', function (e) {
        if (e.target.closest('[data-no-auto]')) return;
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    });
  }

  function init() {
    subMenus(); searchOverlay(); cartEvents(); stickyAtc(); zoom(); facetForm(); recentlyViewed();
  }
  ready(init);
  document.addEventListener('shopify:section:load', function () {
    subMenus(); zoom(); facetForm(); stickyAtc();
  });
})();
